module.exports = function getResource(label, vars = []) {
    let resources = {
        size: `SIZE ${vars[0]}`,
        item: `ITEM ${vars[0]}`
    };
    return resources[label];
};
